import { createFeature, createReducer, on } from '@ngrx/store';
import { UIActions } from '../actions/ui.actions';

export interface UIState {
  countRequestInProgress: number;
}

export const initialUIState: UIState = {
  countRequestInProgress: 0,
};

export const uiFeature = createFeature({
  name: 'ui',
  reducer: createReducer(
    initialUIState,
    on(UIActions.requestSent, (state) => ({
      ...state,
      countRequestInProgress: state.countRequestInProgress + 1,
    })),
    on(UIActions.requestCompleted, (state) => ({
      ...state,
      countRequestInProgress: state.countRequestInProgress - 1,
    })),
  ),
});